'use client'

import { create, StateCreator } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

export type OpenOptions = {
  closeOnOpen?: boolean
}

export type DialogState = {
  dialogs: Record<string, boolean>
  isOpen: (key: string) => boolean
  actions: {
    open: (key: string, options?: OpenOptions) => void
    close: (key: string) => void
    closeAll: () => void
    toggle: (key: string) => void
  }
}

export const createDialogStore: StateCreator<DialogState> = (set, get) => ({
  dialogs: {},
  isOpen: key => {
    const state = get()

    return state.dialogs?.[key] || false
  },
  actions: {
    open: (key, { closeOnOpen = false } = {}) => {
      set(state => {
        if (closeOnOpen) {
          return { dialogs: { [key]: true } }
        }

        return { dialogs: { ...state.dialogs, [key]: true } }
      })
    },
    close: key => {
      set(state => {
        if (state.dialogs[key]) {
          return { dialogs: { ...state.dialogs, [key]: false } }
        }

        return { dialogs: { ...state.dialogs } }
      })
    },
    closeAll: () => {
      set({ dialogs: {} })
    },
    toggle: key => {
      set(state => ({
        dialogs: { ...state.dialogs, [key]: !(state.dialogs[key] || false) },
      }))
    },
  },
})

export const useDialogStore = create<DialogState>()(
  subscribeWithSelector(createDialogStore),
)
